import { render, staticRenderFns } from "./StillValidConfirmModal.vue?vue&type=template&id=27d8bdea"
import script from "./StillValidConfirmModal.vue?vue&type=script&lang=ts"
export * from "./StillValidConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports